"use client";

import { useEffect, useState } from "react";
import {
  Form,
  Input,
  Card,
  Button,
  Select,
  Typography,
  Space,
  Tooltip,
  Row,
  Col,
  InputNumber,
  DatePicker,
} from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import PreviewTable from "../../../component/PreviewTable";
import { BOM } from "../../../../../services/definedMethod";
import { labelConfig } from "../../../contractbooking.config";

const { Title, Paragraph } = Typography;
const { Option } = Select;

const ContractInformationForm = ({
  onSearch,
  searchParam,
  customerInfo,
  showDetailsForm,
  handleSearchInTable,
  onFinish,
  form,
  initialValues,
  onChangeProduct,
  productData,
  userData,
  isCreateScreen,
  custodianOptions,
  placementTypeOptions,
  collateralTypeOptions,
  currencies,
}) => {
  const isSearchDisabled =
    !searchParam || searchParam?.length < 5 ? true : false;

  const [allowCollatoral, setAllowCollatoral] = useState(false);
  const placementType = Form.useWatch("placementType", form);
  const custodian = Form.useWatch("custodian", form);
  console.log(custodian);

  useEffect(() => {
    if (placementType === 0) {
      setAllowCollatoral(true);
    }
  }, [placementType]);

  const handlePlacementTypeChange = (value) => {
    // Enable collateral when placement type is secured
    if (value === 0) {
      setAllowCollatoral(true);
    } else {
      setAllowCollatoral(false);
    }
  };

  const dataSections = [
    {
      name: "Customer Name",
      labelValue: customerInfo?.name,
    },
    {
      name: "Customer No.",
      labelValue: customerInfo?.clientno,
    },
    {
      name: "Customer Type",
      labelValue: customerInfo?.customerType || "----",
    },
    {
      name: "Customer Branch",
      labelValue: customerInfo?.branch || "----",
    },
  ];

  return (
    <div className="form-section">
      <h2 style={{ margin: 0, fontSize: "24px" }}>Contract Information</h2>
      <p style={{ marginTop: "5px", color: "#6b7280" }}>
        Retrieve customer info
      </p>

      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ ...initialValues, initiatedBy: userData.username }}
      >
        <Row>
          {isCreateScreen && (
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Space>
                    Customer ID.
                    <Tooltip title="Customer ID.">
                      <InfoCircleOutlined />
                    </Tooltip>
                  </Space>
                }
                name={"customerNumber"}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "80% 17%",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Input
                    onChange={handleSearchInTable}
                    placeholder="Search by customer ID"
                    style={{ height: "44px" }}
                  />
                  <Button
                    disabled={isSearchDisabled}
                    style={{
                      border: "1px solid #EAECF0",
                      backgroundColor: !isSearchDisabled
                        ? "#BA24D5"
                        : "#F2F4F7",
                      color: !isSearchDisabled ? "white" : "#98A2B3",
                      marginTop: 5,
                    }}
                    onClick={onSearch}
                  >
                    Search
                  </Button>
                </div>
              </Form.Item>
            </Col>
          )}

          <Col />
          {showDetailsForm && (
            <Col span={24} style={{ padding: "0px 8px", marginBottom: 30 }}>
              <PreviewTable data={dataSections} />
            </Col>
          )}

          <Col span={24} style={{ padding: "0px 0px", marginTop: 15 }}>
            <Title style={{ marginInline: 0, marginBlock: 0 }} level={4}>
              Product Information
            </Title>
            <p style={{ color: "#6b7280", marginTop: 8 }}>
              Select a Product For Contract Setup
            </p>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  {labelConfig.productName}
                  <Tooltip title="Select Product Name">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"productName"}
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.productName),
                },
              ]}
            >
              <Select
                showSearch
                disabled={!showDetailsForm}
                allowClear
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? "").includes(
                    input?.toLowerCase()
                  )
                }
                placeholder={BOM.handlePlaceholderMsg(
                  labelConfig.productName,
                  "select"
                )}
                // placeholder="Search by product code"
                optionFilterProp="children"
                style={{ height: "44px" }}
                onChange={onChangeProduct}
                options={productData}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  {labelConfig.productCode}
                  <Tooltip title="Product Code">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"productCode"}
              rules={[
                {
                  required: true,
                  message: BOM.CheckReqFld(labelConfig.productCode),
                },
              ]}
            >
              <Input
                className="of-bold-disable-input"
                placeholder="Interbank"
                style={{ height: "44px" }}
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Product Type
                  <Tooltip title="Product Type">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"productType"}
            >
              <Input
                className="of-bold-disable-input"
                placeholder="Loan"
                style={{ height: "44px" }}
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Currency
                  <Tooltip title="Currency">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"currencyCode"}
            >
              <Input
                className="of-bold-disable-input"
                placeholder="Nigerian Naira (#)"
                style={{ height: "44px" }}
                disabled
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Custodian
                  <Tooltip title="Select custodian">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="custodian"
              rules={[
                {
                  required: true,
                  message: "Please select custodian",
                },
              ]}
            >
              <Select
                disabled={!showDetailsForm}
                options={custodianOptions}
                placeholder={"Select custodian"}
                style={{ height: 44 }}
                showSearch
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Placement Type
                  <Tooltip title="Placement Type">
                    <InfoCircleOutlined style={{ color: "#98A2B3" }} />
                  </Tooltip>
                </Space>
              }
              style={{ marginBottom: 24 }}
              name="placementType"
              rules={[
                { required: true, message: "Please enter placement type" },
              ]}
            >
              <Select
                disabled={!showDetailsForm}
                placeholder="Secured/Unsecured"
                style={{ width: "100%", height: "44px" }}
                onChange={handlePlacementTypeChange}
                options={placementTypeOptions}
                validateTrigger={["onChange", "onBlur"]}
              />
            </Form.Item>
          </Col>

          {allowCollatoral && (
            <>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={
                    <Space>
                      Collateral Type
                      <Tooltip title="Collateral Type">
                        <InfoCircleOutlined style={{ color: "#98A2B3" }} />
                      </Tooltip>
                    </Space>
                  }
                  style={{ marginBottom: 24 }}
                  name={"collateralTypeId"}
                  rules={[
                    { required: true, message: "Please enter collateral type" },
                  ]}
                >
                  <Select
                    disabled={!showDetailsForm}
                    placeholder="Collateral Type"
                    style={{ width: "100%", height: "44px" }}
                    options={collateralTypeOptions}
                    allowClear
                  />
                </Form.Item>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={
                    <Space>
                      Collateral Volume
                      <Tooltip title="Collateral Volume">
                        <InfoCircleOutlined style={{ color: "#98A2B3" }} />
                      </Tooltip>
                    </Space>
                  }
                  style={{ marginBottom: 24 }}
                  name={"collateralVolume"}
                  rules={[
                    {
                      required: true,
                      message: "Please enter collateral volume",
                    },
                    {
                      pattern: /^\d+$/,
                      message: "Please enter a valid number",
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%", height: "44px" }}
                    placeholder="0"
                    min={0}
                    className="of-bold-disable-input"
                    formatter={(value) =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={(value) => value?.replace(/,/g, "")}
                  />
                </Form.Item>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={
                    <Space>
                      Collateral Number
                      <Tooltip title="Collateral Number">
                        <InfoCircleOutlined style={{ color: "#98A2B3" }} />
                      </Tooltip>
                    </Space>
                  }
                  style={{ marginBottom: 24 }}
                  name={"collateralNumber"}
                  rules={[
                    {
                      required: true,
                      message: "Please enter collateral number",
                    },
                  ]}
                >
                  <Input
                    style={{ flex: 1, height: "44px" }}
                    placeholder="Collateral Number"
                    className="of-bold-disable-input"
                  />
                </Form.Item>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={
                    <Space>
                      Collateral Value
                      <Tooltip title="Collateral Value">
                        <InfoCircleOutlined style={{ color: "#98A2B3" }} />
                      </Tooltip>
                    </Space>
                  }
                  style={{ marginBottom: 0 }}
                >
                  <Input.Group compact>
                    <Form.Item
                      name="collateralCurrency"
                      noStyle
                      rules={[
                        { required: true, message: "Currency is required" },
                      ]}
                    >
                      <Select
                        style={{ width: 100, height: 44 }}
                        placeholder="Currency"
                        options={currencies}
                      />
                    </Form.Item>

                    <Form.Item
                      name="collateralValue"
                      noStyle
                      rules={[
                        {
                          required: true,
                          message: "Please enter collateral value",
                        },
                      ]}
                    >
                      <InputNumber
                        style={{ width: "calc(100% - 100px)", height: 44 }}
                        placeholder="0"
                        min={0}
                        formatter={(value) =>
                          `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }
                        parser={(value) => value?.replace(/,/g, "")}
                      />
                    </Form.Item>
                  </Input.Group>
                </Form.Item>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={
                    <Space>
                      Collateral Maturity Date
                      <Tooltip title="Collateral Maturity Date">
                        <InfoCircleOutlined style={{ color: "#98A2B3" }} />
                      </Tooltip>
                    </Space>
                  }
                  style={{ marginBottom: 24 }}
                  name={"collateralMaturityDate"}
                  rules={[
                    {
                      required: true,
                      message: "Please enter collateral maturity date",
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%", height: "44px", marginBottom: 0 }}
                    placeholder="Select date"
                    // disabledDate={(current) => {
                    //   const startOfYear = dayjs().startOf("year");
                    //   return (
                    //     current && (current > dayjs() || current < startOfYear)
                    //   );
                    // }}
                  />
                </Form.Item>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={
                    <Space>
                      Collateral Reference/Identifier
                      <Tooltip title="Collateral Reference">
                        <InfoCircleOutlined style={{ color: "#98A2B3" }} />
                      </Tooltip>
                    </Space>
                  }
                  style={{ marginBottom: 24 }}
                  name={"collateralIdentifier"}
                >
                  <Input
                    style={{ width: "100%", height: "44px" }}
                    placeholder="Collateral Collateral Reference"
                    // onChange={(value) =>
                    //   handleInputChange("collateralIdentifier", value)
                    // }
                    className="of-bold-disable-input"
                  />
                </Form.Item>
              </Col>
            </>
          )}
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <Space>
                  Inputter
                  <Tooltip title="Person inputting the data">
                    <InfoCircleOutlined />
                  </Tooltip>
                </Space>
              }
              name={"initiatedBy"}
            >
              <Input
                value={userData?.username}
                className="of-bold-disable-input"
                placeholder="Matthew Ola"
                style={{ height: "44px" }}
                disabled
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ContractInformationForm;
